/**
 * get query params from URL(via default vue query object)
 * and pass it to component props
 */
export function routePropResolver (routeOptions) {
  const { query } = routeOptions
  const resultQuery = {}
-
  Object.keys(query).forEach(key => {
    // parse strings
    if (query[key].length && !['0', 'null', 'undefined', 'NaN'].includes(query[key])) {
      resultQuery[key] = query[key]
    }
    // parse numbers
    if (parseInt(query[key])) {
      resultQuery[key] = +query[key]
    }
  })
  return resultQuery
}

/**
 * validate route limit
 * API have default limit equals to 10, so we don't need send it
 * @param {int} limit
 * @return {boolean}
 */
export function isValidLimitQuery (limit) {
  return [20, 30, 40, 50, 100].includes(+limit)
}

/**
 * validate route page
 * API have default page equals to 0, so we don't need send it
 * @param {int} page
 * @return {boolean}
 */
export function isValidPageQuery (page) {
  return +page >= 1
}

/**
 * parse hash params to object if there is one;
 * @param {string} hashString
 * @return {Object, null}
 */
export function parseHashParams(hashString) {
  if (!hashString) return;

  hashString = hashString.replace("#", "");
  const params = new URLSearchParams(hashString);

  return Object.fromEntries(params);
}

/**
 * Só o hash mudou (mesmo caminho e mesma query): `#comentario-{id}` do push ou do
 * sino na aula já aberta, `#00:01:30` do salto de tempo, e o `replace({ hash: "" })`
 * que a aula faz para limpá-los. Navegação assim não troca de tela: não volta a
 * rolagem para o topo nem refaz o GET do sino no guard.
 */
export function isHashOnlyChange (to, from) {
  if (!to || !from) return false
  return withoutHash(to.fullPath) === withoutHash(from.fullPath) && (to.hash || '') !== (from.hash || '')
}

function withoutHash (fullPath) {
  const path = fullPath || ''
  const index = path.indexOf('#')
  return index === -1 ? path : path.slice(0, index)
}
